export default function Successful() {
  return (
    <div>
      <h1>Herzlichen Glückwunsch</h1>
      <p>Hier können Sie ihren Gutschein herunterladen...</p>
    </div>
  );
}
